import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[ui-section-header-text]',
})
export class UiSectionTextDirective {
  constructor() {}
  @HostBinding('class') elClass = 'ui-section-header-text';
}
